import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ApiPagingResults, ApiWrapper, BaseMessages, Filters, FormatList, Orders } from '../../types/utils';
import { AssetReservationConfiguration, BookableAssetList, ReservationList } from '../../types/assetReservation';

export class JAssetReservation extends JBaseApi {
    public configuration(): Promise<ApiWrapper<AssetReservationConfiguration>> {
        return this.network.post({
            o: 'assetReservation',
            f: 'configuration',
        } as OF);
    }
    public createReservation(params: {
        uri: string;
        date: string;
        hourStart: string;
        hourEnd: string;
        uriUser?: string;
        description?: string;
    }): Promise<ApiWrapper<ReservationList, BaseMessages>> {
        return this.network.postCSRF({
            o: 'assetReservation',
            f: 'createReservation',
            format: 'raw-list',
            ...params,
        } as OF);
    }

    public getReservations({
        format = 'raw-list',
        ...params
    }: {
        format?: FormatList;
        uri: string;
        dateStart: string;
        dateEnd: string;
    }): Promise<ApiWrapper<ReservationList[], BaseMessages>> {
        return this.network.post({
            o: 'assetReservation',
            f: 'getReservations',
            format,
            ...params,
        } as OF);
    }

    public cancelReservation(id: number): Promise<ApiWrapper<ReservationList, BaseMessages>> {
        return this.network.post({
            o: 'assetReservation',
            f: 'cancelReservation',
            format: 'raw-list',
            idArticle: id,
        } as OF);
    }

    public bookByDate({
        format = 'raw-list',
        ...params
    }: {
        format?: FormatList;
        date: string;
        hourStart: string;
        hourEnd: string;
    }): Promise<ApiWrapper<BookableAssetList[], BaseMessages>> {
        return this.network.post({
            o: 'assetReservation',
            f: 'BookByDate',
            format,
            ...params,
        } as OF);
    }

    public getList({
        format = 'raw-list',
        ...params
    }: {
        format?: FormatList;
        query?: string;
        limit?: number;
        page?: number;
        orders?: Orders;
        filters?: Filters | undefined;
        viewMode?: 'history' | undefined;
    }): Promise<ApiPagingResults<ReservationList>> {
        return this.network.post({
            o: 'objectList',
            f: 'assetReservationList',
            format,
            ...params,
        } as OF);
    }
}
